import { Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { Mark } from '@/components/Mark'

/**
 * The name, on every page somebody can arrive at cold.
 *
 * Six public pages had four different versions of this lockup and three of
 * them — pay, join, unsubscribe — had none at all. Those three are precisely
 * the ones reached from an email or a WhatsApp message by somebody who has
 * never heard of us, which is the moment a name is worth the most.
 *
 * `to` is optional: on the pay page there is nowhere useful to send a stranger
 * with no account, so it renders as plain text rather than a link that lands
 * them on a sign-in they do not need.
 */
export function PublicHeader({
  size = 18,
  to,
}: {
  size?: number
  to?: string
}) {
  const inner = (
    <>
      <Mark size={size} />
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: size >= 28 ? '1.375rem' : '0.9375rem',
          letterSpacing: '-0.02em',
          color: 'text.primary',
        }}
      >
        Fronted
      </Typography>
    </>
  )

  return to ? (
    <Stack
      component={RouterLink}
      to={to}
      direction="row"
      alignItems="center"
      spacing={0.875}
      sx={{ textDecoration: 'none', mb: 2 }}
    >
      {inner}
    </Stack>
  ) : (
    <Stack direction="row" alignItems="center" spacing={0.875} sx={{ mb: 2 }}>
      {inner}
    </Stack>
  )
}
